import { render, staticRenderFns } from "./departman.vue?vue&type=template&id=572e87af&"
import script from "./departman.vue?vue&type=script&lang=js&"
export * from "./departman.vue?vue&type=script&lang=js&"
import style0 from "./departman.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports